import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Features } from '../../assets/features/Features';
import './InfoButton.css';

const InfoButton = () => {
    const { language } = useLanguage();
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
    const buttonRef = useRef(null);
    const tooltipRef = useRef(null);

    useEffect(() => {
        if (showTooltip && buttonRef.current && tooltipRef.current) {
            const buttonRect = buttonRef.current.getBoundingClientRect();
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            
            // Position tooltip below the button, centered
            const top = buttonRect.bottom + 8;
            const left = buttonRect.left + (buttonRect.width / 2) - (tooltipRect.width / 2);
            
            setTooltipPosition({ top, left });
        }
    }, [showTooltip]);

    return (
        <>
            <div 
                className="info-button-wrapper"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                onClick={(e) => e.stopPropagation()}
            >
                <button 
                    ref={buttonRef}
                    className="info-button"
                    aria-label={Features.REGISTRATION.TOOLTIP[language]}
                    type="button"
                    onClick={(e) => e.stopPropagation()}
                >
                    <i className="fas fa-info"></i>
                </button>
            </div>
            {showTooltip && (
                <div 
                    ref={tooltipRef}
                    className="info-tooltip"
                    style={{
                        top: `${tooltipPosition.top}px`,
                        left: `${tooltipPosition.left}px`
                    }}
                >
                    <div className="info-tooltip__content">{Features.REGISTRATION.TOOLTIP[language]}</div>
                </div>
            )}
        </>
    );
};

export default InfoButton;

